import { render, staticRenderFns } from "./DefiLockUnlock.vue?vue&type=template&id=477e9d48&"
import script from "./DefiLockUnlock.vue?vue&type=script&lang=js&"
export * from "./DefiLockUnlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports